<template>
  <div class="container my-4">
    <button class="btn btn-danger rounded-pill my-2" @click="()=>{clearForm();showModal()}">
      <i class="fas fa-plus"></i> آدرس جدید
    </button>

    <div class="vld-parent">
      <loading
        :active.sync="loading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="false"
        :height="25"
        :width="25"
      ></loading>
      <div>
        <div v-for="address in addresses.data" :key="address.id">
          <address-component
            :address="address"
            v-on:edit="editAddress"
            v-on:delete="showRemoveModal"
            v-on:select="selectAddress"
            :selectable="true"
          ></address-component>
        </div>
        <div class="section" v-if="addresses.data.length === 0">
          <p>{{ noLabel }}</p>
        </div>
      </div>
      <b-pagination
        v-show="addresses.data.length > 0 && addresses.data.length > addresses.pagination.perPage "
        v-model="query.page"
        :total-rows="addresses.pagination.total"
        :per-page="addresses.pagination.perPage"
        class="mt-4"
        align="center"
        @input="fetchAddresses"
        pills
      ></b-pagination>
    </div>

    <b-modal
      id="modal-address"
      ref="modal-address"
      title="آدرس جدید"
      cancel-title="انصراف"
      ok-title="ثبت"
      @ok="submitForm"
      size="xl"
      scrollable
      @shown="modalShown"
    >
      <form ref="form" @submit.stop.prevent="submitForm">
        <b-form-group
          :state="!form.titleHasError"
          label="عنوان"
          label-for="title-input"
          :invalid-feedback="form.titleErrorMessage"
        >
          <b-form-input
            id="title-input"
            placeholder="(  منزل - محل کار و ... )"
            name="title"
            v-model="form.title"
            @keyup="checkTitle(form.title)"
            :state="!form.titleHasError"
            required
            is-invalid="true"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="!form.telHasError"
          label="تلفن"
          label-for="tel-input"
          :invalid-feedback="form.telErrorMessage"
        >
          <b-form-input
            id="tel-input"
            placeholder="( 3531111111 )"
            name="tel"
            v-model="form.tel"
            @keyup="checkTel(form.tel)"
            :state="!form.telHasError"
            required
            is-invalid="true"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="!form.mobileHasError"
          label="موبایل (بدون صفر)"
          label-for="mobile-input"
          :invalid-feedback="form.mobileErrorMessage"
        >
          <b-form-input
            id="mobile-input"
            placeholder="( 9131111111 )"
            name="mobile"
            v-model="form.mobile"
            @keyup="checkMobile(form.mobile)"
            :state="!form.mobileHasError"
            required
            is-invalid="true"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="!form.addressHasError"
          label="آدرس"
          label-for="address-input"
          :invalid-feedback="form.addressErrorMessage"
        >
          <b-form-textarea
            id="address-input"
            placeholder="( آدرس )"
            name="address"
            v-model="form.address"
            @keyup="checkAddress(form.address)"
            :state="!form.addressHasError"
            required
          ></b-form-textarea>
        </b-form-group>

        <b-form-group
          :state="!form.latHasError"
          label="عرض جغرافیایی"
          label-for="lat-input"
          :invalid-feedback="form.latErrorMessage"
        >
          <b-form-input
            id="lat-input"
            placeholder="( عرض جغرافیایی )"
            name="lat"
            v-model="form.lat"
            :state="!form.latHasError"
            required
            is-invalid="true"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          :state="!form.lngHasError"
          label="طول جغرافیایی"
          label-for="lng-input"
          :invalid-feedback="form.lngErrorMessage"
        >
          <b-form-input
            id="lng-input"
            placeholder="( طول جغرافیایی )"
            name="lng"
            v-model="form.lng"
            :state="!form.lngHasError"
            required
            is-invalid="true"
          ></b-form-input>
        </b-form-group>

        <hr class="my-5" />

        <div class="leaflet-maps-warper">
          <address-map-marker
            ref="addressMarkerMap"
            v-on:changeMarker="setLatLng"
            :lat="form.lat"
            :lng="form.lng"
          ></address-map-marker>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="modal-remove-address"
      ref="modal-remove-address"
      centered
      title="حذف آدرس"
      cancel-title="انصراف"
      ok-title="تایید"
      @ok="deleteAddress"
      headerClass="border-bottom-0"
      footerClass="border-top-0"
    >
      <div class="message">
        آیا از حذف آدرس
        <span class="bold">{{currentAddress ? currentAddress.title : null}}</span> اطمینان دارید؟
      </div>
    </b-modal>
  </div>
</template>

<script>
import AddresseComponent from "./AddressItem";
import { getByTitle } from "../../filters";
import { mapGetters } from "vuex";
import { isValidEmail, isValidTel, isValidMobile } from "../../validators";
import AddressMapMarker from "../../components/maps/leaflet-maps/addressMapMarker";

export default {
  name: "addresses-list-component",

  components: {
    "address-component": AddresseComponent,
    "address-map-marker": AddressMapMarker,
  },

  metaInfo:{
     title:"آدرس",
      //meta: [{ name: "description", content: "My page meta description" }],
   },

  data() {
    return {
      loading: false,
      noLabel: "آدرسی یافت نشد!",
      addressesFiltered: [],

      form: {
        id: null,
        title: "",
        address: "",
        tel: "",
        mobile: "",
        lat: null,
        lng: null,
        titleHasError: false,
        titleErrorMessage: "",
        titleReqiuredMessage: "عنوان نمی تواند خالی باشد.",
        addressHasError: false,
        addressErrorMessage: "",
        addressReqiuredMessage: "آدرس نمی تواند خالی باشد.",
        telHasError: false,
        telErrorMessage: "",
        telReqiuredMessage: "تلفن نمی تواند خالی باشد.",
        telNotValidMessage: "تلفن معتبر نمی باشد.",
        mobileHasError: false,
        mobileErrorMessage: "",
        mobileReqiuredMessage: "موبایل نمی تواند خالی باشد.",
        mobileNotValidMessage: "موبایل معتبر نمی باشد.",
        latHasError: false,
        latErrorMessage: "",
        latReqiuredMessage: "عرض جغرافیایی نمی تواند خالی باشد.",
        lngHasError: false,
        lngErrorMessage: "",
        lngReqiuredMessage: "طول جغرافیایی نمی تواند خالی باشد.",
      },

      currentAddress: null,

      query: {
        title: undefined,
        page:
          this.addresses && this.addresses.pagination.page
            ? this.addresses.pagination.page
            : 1,
        limit:
          this.addresses && this.addresses.pagination.perPage
            ? this.addresses.pagination.perPage
            : 20,
      },
    };
  },

  computed: {
    ...mapGetters({
      addresses: "addresses",
    }),
  },

  watch: {},

  mounted() {
    this.fetchAddresses();
  },

  methods: {
    fetchAddresses() {
      this.loading = true;
      this.updateQueryParameters();
      this.$store.dispatch("fetchAddresses", this.query).then(() => {
        this.loading = false;
      });
    },

    editAddress(address) {
      this.form = {
        ...this.form,
        ...address,
      };
      this.checkValidateForm();
      this.showModal();
    },

    deleteAddress() {
      this.$store.dispatch("destroyAddress", this.currentAddress.id);
    },

    selectAddress(address) {
      this.$store.dispatch("setCartAddress", address);
      this.$router.push({ path: 'checkout' })
    },

    setLatLng(latlng) {
      this.form.lat = latlng.lat;
      this.form.lng = latlng.lng;
    },

    updateQueryParameters() {
      if (this.query.page > 1) {
        // eslint-disable-next-line
        this.$router.replace({ query: { page: this.query.page } });
      } else if (this.query.page === 1) {
        // eslint-disable-next-line
        this.$router.replace({ query: {} });
      }
    },

    onCancel() {},

    clearForm() {
      const newFrom = {
        id: null,
        title: "",
        address: "",
        tel: "",
        mobile: "",
        lat: null,
        lng: null,
        titleHasError: false,
        titleErrorMessage: "",
        addressHasError: false,
        addressErrorMessage: "",
        telHasError: false,
        telErrorMessage: "",
        mobileHasError: false,
        mobileErrorMessage: "",
        latHasError: false,
        latErrorMessage: "",
        lngHasError: false,
        lngErrorMessage: "",
      };

      this.form = {
        ...this.form,
        ...newFrom,
      };
    },

    showModal() {
      this.$refs["modal-address"].show();
    },
    closeModal() {
      this.$refs["modal-address"].hide();
    },

    showRemoveModal(address) {
      this.currentAddress = address;
      this.$refs["modal-remove-address"].show();
    },
    closeRemoveModal() {
      this.$refs["modal-remove-address"].hide();
    },

    checkValidateForm() {
      this.checkTitle(this.form.title);

      this.checkAddress(this.form.address);

      this.checkTel(this.form.tel);

      this.checkMobile(this.form.mobile);

      if (!this.form.lat) {
        this.form.latHasError = true;
        this.form.latErrorMessage = this.form.latReqiuredMessage;
      } else {
        this.form.latHasError = false;
      }

      if (!this.form.lng) {
        this.form.lngHasError = true;
        this.form.lngErrorMessage = this.form.lngReqiuredMessage;
      } else {
        this.form.lngHasError = false;
      }

      if (
        !this.form.titleHasError &&
        !this.form.addressHasError &&
        !this.form.mobileHasError &&
        !this.form.telHasError &&
        !this.form.latHasError &&
        !this.form.lngHasError
      ) {
        return true;
      }

      return false;
    },

    submitForm(e) {
      e.preventDefault();

      if (this.checkValidateForm()) {
        this.$store
          .dispatch("saveAddress", this.form)
          .then(() => {
            this.closeModal();
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },

    checkTitle(titleValue) {
      if (titleValue) {
        this.form.titleHasError = false;
        this.form.titleErrorMessage = "";
      } else {
        this.form.titleHasError = true;
        this.form.titleErrorMessage = this.form.titleReqiuredMessage;
      }
    },

    checkAddress(addressValue) {
      if (addressValue) {
        this.form.addressHasError = false;
        this.form.addressErrorMessage = "";
      } else {
        this.form.addressHasError = true;
        this.form.addressErrorMessage = this.form.addressReqiuredMessage;
      }
    },

    checkTel(telValue) {
      if (telValue && isValidTel(telValue)) {
        this.form.telHasError = false;
      } else {
        this.form.telHasError = true;

        if (telValue) {
          this.form.telErrorMessage = this.form.telNotValidMessage;
        } else {
          this.form.telErrorMessage = this.form.telReqiuredMessage;
        }
      }
    },

    checkMobile(mobileValue) {
      if (mobileValue && isValidMobile(mobileValue)) {
        this.form.mobileHasError = false;
      } else {
        this.form.mobileHasError = true;

        if (mobileValue) {
          this.form.mobileErrorMessage = this.form.mobileNotValidMessage;
        } else {
          this.form.mobileErrorMessage = this.form.mobileReqiuredMessage;
        }
      }
    },

    modalShown() {
      setTimeout(() => {
        //mapObject is a property that is part of leaflet
        this.$refs.addressMarkerMap.$refs.map.mapObject.invalidateSize();
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  margin: 10px;
}
.message {
  font-size: 1.12rem;
}
.bold {
  font-weight: bold;
  color: #ef394f;
}

.leaflet-maps-warper {
  height: 400px;
  width: 100%;
}
</style>
